var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.messages.length)?_c('div',{staticClass:"MBMWidget_Snack MBMWidget_mb-4",class:_vm.colors},_vm._l((_vm.messages),function(message){return _c('div',{key:message},[_vm._v("* "+_vm._s(message))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }